import React from "react"

import "./embedBlock.scss"

// TODO: Build out more robust for an oEmbed service on Vibemap.com
const EmbedBlock = ({ block }) => {

  return (
    <div className={`wp-block ${block.name.replace("/", "-")}`}>
      <div className="container heading">
        {block.embed.heading && (
          <h3>{block.embed.heading}</h3>
        )}

        <div dangerouslySetInnerHTML={{
          __html: block.embed.embedCode
        }}/>
      </div>
    </div>
  )
}

export default EmbedBlock
